import { create } from 'zustand'
import type { DrillDescriptor, DrillSort } from '@/types/dashboards'

export const DRILL_PAGE_SIZE = 50

interface DashboardDrillState {
  isOpen: boolean
  descriptor: DrillDescriptor | null
  page: number
  pageSize: number
  sort: DrillSort | null
  openDrill: (descriptor: DrillDescriptor) => void
  closeDrill: () => void
  setPage: (page: number) => void
  /** Server-side sort: flips direction on the active key, otherwise selects it. */
  toggleSort: (key: string) => void
}

/**
 * Drives the one drill-down dialog every board shares.
 *
 * Paging and sort live here rather than in the dialog so opening a new figure
 * resets them — carrying page 4 of the previous record set into a different
 * dataset shows an empty table behind a correct-looking number.
 */
export const useDashboardDrillStore = create<DashboardDrillState>((set) => ({
  isOpen: false,
  descriptor: null,
  page: 1,
  pageSize: DRILL_PAGE_SIZE,
  sort: null,
  openDrill: (descriptor) =>
    set({ isOpen: true, descriptor, page: 1, pageSize: DRILL_PAGE_SIZE, sort: null }),
  closeDrill: () => set({ isOpen: false, descriptor: null, page: 1, sort: null }),
  setPage: (page) => set({ page: Math.max(1, page) }),
  toggleSort: (key) =>
    set((state) => ({
      page: 1,
      sort:
        state.sort?.key === key
          ? { key, dir: state.sort.dir === 'asc' ? 'desc' : 'asc' }
          : { key, dir: 'desc' },
    })),
}))
